import React from "react";
import { Segment, Image } from "semantic-ui-react";

import notFound from "./notfound.png";

import "./styles.css";

function NotFound({ history }) {
  return (
    <div className="not-found-container">
      <Segment padded="very" color="blue">
        <Image fluid src={notFound} alt="404 Not Found" />
      </Segment>
    </div>
  );
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound/index.jsx